import { Component, ElementRef, Input } from '@angular/core';
import { Orientation } from '../../../Orientation';
import { Range } from '../../Primitives/Range/Range';

/**
 * @public
 */
// tslint:disable-next-line: prefer-on-push-component-change-detection
@Component({
  selector: `ui-progress-bar`,
  templateUrl: './ProgressBar.html',
  standalone: false
})
export class ProgressBarComponent extends Range {
  private _isIndeterminate: boolean;
  private _orientation: Orientation;

  public constructor(element: ElementRef<HTMLElement>) {
    super(element);

    this.role = 'progressbar';

    this._isIndeterminate = false;
    this._orientation = Orientation.Horizontal;
  }

  /**
   * Determines if `ProgressBar` shows actual values `false` or generic, continuous progress feedback `true`.
   * @public
   * @type boolean
   * @default false
   */
  @Input()
  public get isIndeterminate(): boolean {
    return this._isIndeterminate;
  }
  public set isIndeterminate(value: boolean) {
    this._isIndeterminate = value;
  }

  /**
   * Specifies orientation of the `ProgressBar`.
   * @public
   * @type boolean
   * @default false
   */
  @Input()
  public get orientation(): Orientation {
    return this._orientation;
  }
  public set orientation(value: Orientation) {
    this._orientation = value;
  }
}
